// Copyright (c) StrangeBee 2024

import DisplayPermissions from '@Atoms/Display/DisplayPermissions/DisplayPermissions';
import { useLocalMessage } from '@Helpers/';
import React, { ReactElement } from 'react';

interface FormatPermissionsProps {
    profile?: string;
    permissions: string[];
    permissionsOnly?: boolean;
    noPermissionsLabel?: string;
}
const FormatPermissions = ({
    profile = '',
    permissions = [],
    permissionsOnly,
}: FormatPermissionsProps): ReactElement => {
    const i = useLocalMessage();

    return (
        <DisplayPermissions
            permissions={permissions}
            noPermissionsLabel={i('profile.permissions.empty')}
            permissionsOnly={permissionsOnly}
            profile={profile}
        />
    );
};

export default FormatPermissions;
